// extracted by mini-css-extract-plugin
export default {"seriesToggle":"SeriesToggle_seriesToggle__n53WA"};